import { sendOfferLead } from './sendOfferLead'

/**
 * get redirect from Self
 * @param {SelfLead} data
 * @param {string} backupLink
 */
export const redirectToSelf = async (data, backupLink) => {
  try {
    const resp = /** @type {SelfLeadResponse} */ (
      await sendOfferLead('/api/offer/self-lead', data)
    )
    const redirectUrl =
      resp && Array.isArray(resp.products) && resp.products.length
        ? resp.products[0].redirect_url
        : null

    if (redirectUrl) {
      window.location.href = `${redirectUrl}`
      return
    }

    window.location.href = backupLink
  } catch (error) {
    console.error(error)
    window.location.href = backupLink
  }
}
